import { RefProps } from "./types";
import { applyItem, createFieldPath, getNoVoidPath, getShowName, getShowPath, isAttr, popFieldpath, popPath, isFieldPath } from "./utils";
const addProxy = ({ config, key = "", parentPath = "", parent }) => {
  const { proxyRecord } = config;
  const thisPath = `${parentPath ? `${parentPath}.` : ""}${key}`;
  if (!proxyRecord[thisPath]) {
    const thisFieldPath = new Proxy({}, {
      get: (target, prop) => {
        const { aliasMap, voidPathMap } = config;
        const thisPathObj = thisFieldPath;
        switch (prop) {
          case RefProps.name:
            return () => getShowName(aliasMap, thisPathObj, key);
          case RefProps.path:
            return () => getShowPath(aliasMap, thisPathObj);
          case RefProps.noVoidPath:
            return () => getNoVoidPath(voidPathMap, thisPathObj);
          case RefProps.arrayItem:
            return (idx) => addProxy({
              config,
              key: idx === void 0 ? "*" : `${idx}`,
              parentPath: thisPath,
              parent: thisFieldPath
            });
          case RefProps.setAlias:
            return (al) => {
              aliasMap.set(thisPathObj, al);
            };
          case RefProps.isAlias:
            return () => aliasMap.get(thisPathObj) !== void 0;
          case RefProps.setVoid:
            return () => {
              voidPathMap.set(thisPathObj, true);
            };
          case RefProps.isVoid:
            return () => voidPathMap.get(thisPathObj) !== void 0;
          case RefProps.withAttr:
            return (str) => ({
              [RefProps.name]: () => str,
              [RefProps.path]: () => getShowPath(aliasMap, thisPathObj)
            });
          case RefProps.parent:
            return () => parent;
          case RefProps.relative:
            return () => addProxy({
              config
            });
          case RefProps.clear:
            return () => {
              aliasMap.delete(thisPathObj);
              voidPathMap.delete(thisPathObj);
            };
          case RefProps.nameCollection:
            return () => addProxy({
              config,
              key: prop,
              parentPath: thisPath,
              parent: thisFieldPath
            });
          default:
        }
        if (thisPath === RefProps.nameCollection) {
          return prop;
        }
        return addProxy({
          config,
          key: prop,
          parentPath: thisPath,
          parent: thisFieldPath
        });
      }
    });
    proxyRecord[thisPath] = thisFieldPath;
  }
  return proxyRecord[thisPath];
};
export function createFieldModel() {
  const config = {
    aliasMap: /* @__PURE__ */ new Map(),
    voidPathMap: /* @__PURE__ */ new Map(),
    proxyRecord: {}
  };
  const proxyModel = addProxy({
    config
  });
  return proxyModel;
}
export const createStringPath = (fieldPath, path) => (path !== null && path !== void 0 ? path : "").split(".").reduce((pre, cur) => {
  if (cur === "*") {
    return pre[RefProps.arrayItem]();
  }
  return pre[cur];
}, fieldPath);
export { applyItem, createFieldPath, isAttr, popFieldpath, popPath, isFieldPath };
